__turbopack_context__.v({
  "customScroll": "AppSelect-module__5gitiW__customScroll",
});
